export const env = typeof Cypress === 'object' ? Cypress.env() : process.env;
